import React from 'react';
import { Menu } from '@mui/material';
import { styles } from './custom-menu-helpers';

interface CustomMenuProps {
    id: string;
    open: boolean;
    onClose: () => void;
    onClick: () => void;
    anchorEl: HTMLElement | null;
    children: any;
}

export const CustomMenu = ({
    id,
    open,
    onClose,
    onClick,
    anchorEl,
    children,
}: CustomMenuProps): React.JSX.Element => {
    return (
        <Menu
            anchorEl={anchorEl}
            id={id}
            open={open}
            onClose={onClose}
            onClick={onClick}
            slotProps={styles.slotProps}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {children}
        </Menu>
    );
};
